import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import { Bike, Car, Truck, PackageCheck } from "lucide-react";

export const STATUS_META = {
  PENDING: { label: "Pending", color: "bg-amber-100 text-amber-800 border-amber-200" },
  CONFIRMED: { label: "Confirmed", color: "bg-sky-100 text-sky-800 border-sky-200" },
  PREPARING: { label: "Preparing", color: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  READY_FOR_PICKUP: { label: "Ready for pickup", color: "bg-purple-100 text-purple-800 border-purple-200" },
  COURIER_ASSIGNED: { label: "Courier assigned", color: "bg-cyan-100 text-cyan-800 border-cyan-200" },
  COURIER_ARRIVING: { label: "Courier arriving", color: "bg-cyan-100 text-cyan-800 border-cyan-200" },
  PICKED_UP: { label: "Picked up", color: "bg-blue-100 text-blue-800 border-blue-200" },
  IN_TRANSIT: { label: "In transit", color: "bg-orange-100 text-orange-800 border-orange-200" },
  DELIVERED: { label: "Delivered", color: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  CANCELLED: { label: "Cancelled", color: "bg-slate-100 text-slate-700 border-slate-200" },
  REJECTED: { label: "Rejected", color: "bg-red-100 text-red-800 border-red-200" },
  FAILED: { label: "Failed", color: "bg-red-100 text-red-800 border-red-200" },
  REFUNDED: { label: "Refunded", color: "bg-slate-100 text-slate-700 border-slate-200" },
};

export function StatusBadge({ status }) {
  const { t } = useTranslation();
  const m = STATUS_META[status] || { color: "bg-slate-100 text-slate-700" };
  return <Badge data-testid={`status-${status}`} variant="outline" className={`${m.color} font-medium`}>{t(`status.${status}`, status)}</Badge>;
}

export const VEHICLE_ICON = { motorcycle: Bike, car: Car, van: Truck, truck: Truck };
export const VEHICLE_LABEL = { motorcycle: "Motorcycle", car: "Car", van: "Van", truck: "Truck" };

export function VehicleBadge({ type, active }) {
  const { t } = useTranslation();
  const Icon = VEHICLE_ICON[type] || PackageCheck;
  return (
    <div
      data-testid={`vehicle-${type}`}
      className={`flex items-center gap-1.5 px-2.5 py-1 rounded-lg border text-xs font-semibold ${
        active ? "bg-brand text-white border-brand" : "bg-slate-50 text-slate-500 border-slate-200"
      }`}
    >
      <Icon className="w-3.5 h-3.5" />
      {t(`vehicle.${type}`, VEHICLE_LABEL[type] || type)}
    </div>
  );
}

export function Stat({ label, value, icon: Icon, accent = "text-brand" }) {
  return (
    <div className="bg-card border rounded-2xl p-5 flex items-center gap-4">
      {Icon && (
        <div className={`w-11 h-11 rounded-xl bg-accent flex items-center justify-center ${accent}`}>
          <Icon className="w-5 h-5" />
        </div>
      )}
      <div>
        <div className="text-2xl font-bold font-display leading-none">{value}</div>
        <div className="text-xs uppercase tracking-wider text-muted-foreground mt-1">{label}</div>
      </div>
    </div>
  );
}
